import React, { useState, useEffect } from 'react'
import { Table } from 'antd'
import { ColumnProps } from 'antd/es/table'

import TableCell from './TableCell'
import FiltersDisplay from './FiltersDisplay'
import { buildColumn, getActionColumn } from './tableUtils'
import { set } from 'lodash'

interface DataTableProps {
  form?
  title?: string
  subtitle?: string
  dataSource: any[]
  tableActions?: any[]
  errors?: any[] | null
  columns: ColumnsModel[]
  rowActions?: Array<(row: any) => void>
  onRowUpdate?: (newRow: any, row?: any, field?: any, value?: any) => void
}

export interface ColumnsModel extends ColumnProps<any> {
  sortable?: boolean
  validation?: any[]
  filterable?: boolean
  filterKeys?: string[]
  isDate?: boolean
  disabled?: ((row: any) => any) | boolean
  vertical?: Array<string>
  render?: (value: any, row: any) => any
}

const DataTable = ({
  form,
  title,
  columns,
  subtitle,
  rowActions,
  dataSource,
  onRowUpdate,
  tableActions,
  errors = null,
  ...otherProps
}: DataTableProps) => {
  const [filters, setFilters] = useState({})
  const [tableColumns, setTableColumns] = useState()
  const [page, setPage] = useState<number>(1)
  const pageSize = 15
  const [tableKey, setTableKey] = useState(0)
  const resetFilters = () => {
    setFilters({ filters: {} })
    setTableKey(tableKey => tableKey + 1)
  }

  useEffect(() => {
    const newColumns = columns.map(column =>
      buildColumn({ column, errors, form, onUpdate: saveRow, page, pageSize })
    )

    if (rowActions) {
      // @ts-ignore
      newColumns.push(getActionColumn(rowActions))
    }

    // @ts-ignore
    setTableColumns(newColumns)
    // eslint-disable-next-line
  }, [columns, errors, rowActions])

  const saveRow = (row, field, value) => {
    if (onRowUpdate) {
      const newRow = set(row, field, String(value))
      onRowUpdate(newRow, row, field, value)
    }
  }

  const components = { body: { cell: TableCell } }

  return (
    <div className="data-table">
      <FiltersDisplay filters={filters} resetAction={resetFilters} />
      <Table
        key={tableKey}
        rowKey={record => record.id || 'cuid' + Math.random()}
        columns={tableColumns}
        dataSource={dataSource}
        components={components}
        onChange={({ current }, filters) => {
          setPage(current!)
          return setFilters(filters)
        }}
        {...otherProps}
        size="middle"
        bordered
        pagination={{
          current: page,
          pageSize
        }}
      />
    </div>
  )
}

export default DataTable
